import {
    /* Create */
    CREATE_LANDLORD_START,
    CREATE_LANDLORD_SUCCESS,
    CREATE_LANDLORD_FAILED,
    /* Fetch */
    FETCH_LANDLORD_START,
    FETCH_LANDLORD_SUCCESS,
    FETCH_LANDLORD_FAILED,
    /* Update */
    UPDATE_LANDLORD_START,
    UPDATE_LANDLORD_SUCCESS,
    UPDATE_LANDLORD_FAILED,
} from "../store/types";




export const createLandlord = (landlordDetails) => (dispatch) => (firebase) => {
    const { landLordsRef, singleLandLordsRef, auth } = firebase;
    try {
        dispatch({
            type: CREATE_LANDLORD_START,
            payload: null,
        })

        const {
            ownerName,
            companyName,
            companyRegNumber,
            companyContactNumber,
            companyEmail,
            office
        } = landlordDetails;

        const errors = {};

        if (!companyName) errors.companyName = 'Company name is required.';
        if (!ownerName) errors.ownerName = 'Owner name is required.';
        if (!companyContactNumber && !companyEmail) {
            errors.companyContactNumber = 'Either contact number or email is required.';
            errors.companyEmail = 'Either contact number or email is required.';
        }
        if (!office) {
            errors.office = 'Office is required.';
        }


        if (Object.keys(errors).length > 0) {
            dispatch({
                type: CREATE_LANDLORD_FAILED,
                payload: { errors },
            });
            console.log('errors', errors)
            return;
        }


        landLordsRef.push(
            {
                ownerName,
                companyName,
                companyRegNumber,
                companyContactNumber,
                companyEmail,
                office,
                createDate: new Date().getTime(),
            }
        ).then((landlord) => {
            var id = landlord.key;
            singleLandLordsRef(id)
                .update({ id: id })
                .then(() => {
                    dispatch({
                        type: CREATE_LANDLORD_SUCCESS,
                        payload: {
                            ownerName,
                            companyName,
                            companyRegNumber,
                            companyContactNumber,
                            companyEmail,
                            office,
                            createDate: new Date().getTime(),
                            id: id,
                        },
                    })
                })
                .catch((error) => {
                    console.log('error', error)
                    dispatch({
                        type: CREATE_LANDLORD_FAILED,
                        payload: error,
                    })
                })

        }).catch((error) => {
            console.log('error', error)
            dispatch({
                type: CREATE_LANDLORD_FAILED,
                payload: error,
            })
        })



    } catch (error) {
        dispatch({
            type: CREATE_LANDLORD_FAILED,
            payload: null,
        })
    }


}


export const fetchLandlords = (office) => (dispatch) => (firebase) => {
    const { landLordsRef } = firebase;
    try {
        dispatch({
            type: FETCH_LANDLORD_START,
            payload: null,
        })

        landLordsRef
            .orderByChild("office")
            .equalTo(office)
            .once('value')
            .then((snapshot) => {
                const landlords = Object.values(snapshot.val());

                dispatch({
                    type: FETCH_LANDLORD_SUCCESS,
                    payload: landlords,
                })
            }).catch((error) => {
                console.log('error', error)
                dispatch({
                    type: FETCH_LANDLORD_FAILED,
                    payload: error,
                })
            })

    } catch (error) {
        dispatch({
            type: FETCH_LANDLORD_FAILED,
            payload: null,
        })
    }
}


export const updateLandlord = (landlordDetails) => (dispatch) => (firebase) => {
    const { singleLandLordsRef } = firebase;
    try {
        dispatch({
            type: UPDATE_LANDLORD_START,
            payload: null,
        })

        const {
            id,
            ownerName,
            companyName,
            companyRegNumber,
            companyContactNumber,
            companyEmail,
            office
        } = landlordDetails;

        const errors = {};

        if (!companyName) errors.companyName = 'Company name is required.';
        if (!ownerName) errors.ownerName = 'Owner name is required.';
        if (!companyContactNumber && !companyEmail) {
            errors.companyContactNumber = 'Either contact number or email is required.';
            errors.companyEmail = 'Either contact number or email is required.';
        }
        if (!office) {
            errors.office = 'Office is required.';
        }
        if (Object.keys(errors).length > 0) {
            dispatch({
                type: UPDATE_LANDLORD_FAILED,
                payload: { errors },
            });
            console.log('errors', errors)
            return;
        }
        singleLandLordsRef(id)
            .update({
                ownerName,
                companyName,
                companyRegNumber,
                companyContactNumber,
                companyEmail,
                office,
                modifiedDate: new Date().getTime(),
            })
            .then(() => {
                dispatch({
                    type: UPDATE_LANDLORD_SUCCESS,
                    payload: landlordDetails,
                })
            }).catch((error) => {
                console.log('error', error)
                dispatch({
                    type: UPDATE_LANDLORD_FAILED,
                    payload: error,
                })
            })
    }
    catch (error) {
        dispatch({
            type: UPDATE_LANDLORD_FAILED,
            payload: null,
        })
    }
}


